import { render, staticRenderFns } from "./pweread.vue?vue&type=template&id=b30d9db2&scoped=true&"
import script from "./pweread.vue?vue&type=script&lang=js&"
export * from "./pweread.vue?vue&type=script&lang=js&"
import style0 from "./pweread.vue?vue&type=style&index=0&id=b30d9db2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30d9db2",
  null
  
)

export default component.exports